export default __webpack_public_path__ + "static/media/view-lifting-hook-industrial-warehouse.0c9d33cc.webp";